import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import * as _ from 'lodash';
import { ACL } from 'src/app/shared/interfaces/acl';

@Injectable({
    providedIn: 'root'
})
export class AclService {


    constructor(private AuthService: AuthService) {
    }

    async can(permission: string): Promise<boolean> {
        const currentUserRoles = this.AuthService.getUserRoles();
        const roles = ACL[permission];
        const isManager = await this.AuthService.getIsManagerUser().toPromise();

        if(!roles)
            return false;
        else if(roles && roles.some(role => currentUserRoles.includes(role)) || isManager.manager && roles.includes('Manager'))
            return true;
        return roles.includes('*');
    }
}